import update from 'immutability-helper';
import get from 'lodash/get';

import * as DRAWER from './actions';

const defaultState = {
    data: {
        id: null,
    },
    show: false
};

const ACTION_HANDLERS = {

    [DRAWER.SHOW]: (state, action) => {
        return update(state, {
            data: { $set: get(action, 'payload.data') ? get(action, 'payload.data') : defaultState.data},
            show: { $set: true },
        })
    },

    [DRAWER.CLOSE]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    //Close Drawer after data has been created
    [DRAWER.CREATE.SUCCESS]: (state, action) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    //Close Drawer after data has been created
    [DRAWER.SAVE.SUCCESS]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    [DRAWER.DELETE.SUCCESS]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    [DRAWER.STATUS.SUCCESS]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    [DRAWER.START_SERVICE.SUCCESS]: (state, action) => {
        return update(state, {
            data: { $set: action.payload.data.data }
        })
    },

    [DRAWER.ARCHIVE.SUCCESS]: (state) => {
        return update(state, {
            show: { $set: false },
        })
    },

    [DRAWER.ACTIVATE.SUCCESS]: (state) => {
        return update(state, {
            show: { $set: false },
        })
    },

}

const reducer = (state = defaultState, action) => {
    const handler = ACTION_HANDLERS[action.type];
  
    return handler ? handler(state, action) : state;
};

export default reducer;